import type { Framework } from '@toeverything/infra';

import { WorkspaceDBService } from '../db';
import { DocsService } from '../doc';
import { OrganizeService } from '../organize';
import { WorkspaceScope, WorkspacesService } from '../workspace';
import { FolderTemplateList } from './entities/folder-list';
import { TemplateDocList } from './entities/list';
import { TemplateDocSetting } from './entities/setting';
import { FolderTemplateService } from './services/folder-template';
import { TemplateDocService } from './services/template-doc';
import { FolderTemplateListStore } from './store/folder-list';
import { TemplateDocListStore } from './store/list';
import { TemplateDocSettingStore } from './store/setting';

export { FolderTemplateService, TemplateDocService };

export const configureTemplateDocModule = (framework: Framework) => {
  framework
    .scope(WorkspaceScope)
    .service(TemplateDocService)
    .store(TemplateDocListStore, [WorkspaceDBService])
    .entity(TemplateDocList, [TemplateDocListStore, DocsService])
    .store(TemplateDocSettingStore, [WorkspaceDBService])
    .entity(TemplateDocSetting, [TemplateDocSettingStore])
    .store(FolderTemplateListStore, [WorkspaceDBService])
    .entity(FolderTemplateList, [FolderTemplateListStore])
    .service(FolderTemplateService, [
      DocsService,
      OrganizeService,
      WorkspacesService,
    ]);
};
